<div
  class="d-flex align-items-center justify-content-center gap-2"
  [class.small]="size === 'small'"
>
  <img src="./assets/img/logo.png" alt="logo" />

  @if (showTitle) {
    <div class="system-title" [class]="customTitleClass">
      {{ systemName }}
    </div>
  }
</div>
